import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EnviromentService } from 'src/app/Services/enviroment.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  constructor(
    private firebase: AngularFireDatabase,
    private enviromentService: EnviromentService
  ) {
    this.getEndPoints().subscribe((data) => {
      sessionStorage.setItem("endPoints", JSON.stringify(data));
      if (this && this.enviromentService)
        this.enviromentService.getParameterDinamic();
    });
  }

  private readonly _endPoints = new BehaviorSubject<any[]>([]);
  readonly endPoints$ = this._endPoints.asObservable();


  // @ts-ignore
  get endPoints(): any[] {
    return this._endPoints.getValue();
  }

  // @ts-ignore
  set endPoints(val: any[]) {
    this._endPoints.next(val);
  }

  getEndPoints() {
    return this.firebase.list(environment.env + '-endPoints').valueChanges();
  }

}

// import { Injectable } from "@angular/core";
// import { AngularFireDatabase } from "@angular/fire/database";
// import "rxjs/add/operator/map";
// import { BehaviorSubject } from "rxjs";
// import { environment } from "src/environments/environment";
// import { EnviromentService } from "src/app/Services/enviroment.service";
// import { AngularFireAuth } from "@angular/fire/auth";

// @Injectable({
//   providedIn: "root",
// })
// export class FirebaseService {
//   constructor(
//     private firebase: AngularFireDatabase,
//     private enviromentService: EnviromentService,
//     private angularFireAuth: AngularFireAuth,
//   ) {

//   }

//   private readonly _endPoints = new BehaviorSubject<any[]>([]);
//   readonly endPoints$ = this._endPoints.asObservable();

//   // @ts-ignore
//   get endPoints(): any[] {
//     return this._endPoints.getValue();
//   }

//   // @ts-ignore
//   set endPoints(val: any[]) {
//     this._endPoints.next(val);
//   }

//   getEndPoints() {
//     return this.firebase.list(environment.env + "-endPoints").valueChanges();
//   }

//   getEndPointsJwe() {
//     this.getEndPoints().subscribe((data) => {
//       sessionStorage.setItem("endPoints", JSON.stringify(data));
//       if (this && this.enviromentService)
//         this.enviromentService.getParameterDinamic();
//     }, (error) =>{
//       console.log('Not authorized in FireBase')
//     });
//   }

//   loginFireBase(email: string, password: string) {
//     this.angularFireAuth.signInWithEmailAndPassword(email, password)
//     .then((res) => {
//         this.getEndPointsJwe();
//       })
//       .catch((err) => {
//         console.log("Something is wrong:", err.message);
//       });
//   }
// }